import { submitFeedback } from '../../../services/FeedbackService.js';

export default {
    async sendFeedback(context, payload) {
        const feedbackData = {
            recipientType: payload.recipientType,
            schoolId: payload.schoolId || null,
            category: payload.category,
            subject: payload.subject,
            message: payload.message,
            rating: payload.rating || null,
        };

        const response = await submitFeedback(feedbackData, context.rootGetters['auth/getToken']);
        context.commit('setLastFeedback', feedbackData);
        return response;
    },

    clearLastFeedback(context) {
        context.commit('setLastFeedback', null);
    },
};
